/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * Employee Pay Information
 * @export
 * @interface EmployeePayDetails
 */
export interface EmployeePayDetails {
    /**
     * The ID of the Employee Pay this relates to
     * @type {number}
     * @memberof EmployeePayDetails
     */
    id: number;
    /**
     * The ID of the Company this relates to
     * @type {number}
     * @memberof EmployeePayDetails
     */
    companyId: number;
    /**
     * The ID of the Employee this relates to
     * @type {number}
     * @memberof EmployeePayDetails
     */
    employeeId: number;
    /**
     * The ID of the Job Role this relates to
     * @type {number}
     * @memberof EmployeePayDetails
     */
    jobRoleId: number | null;
    /**
     * The ID of the Pay Type this relates to
     * @type {number}
     * @memberof EmployeePayDetails
     */
    payTypeId: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeePayDetails
     */
    payCode: string | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeePayDetails
     */
    startDate: ShiftiePlainDate | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeePayDetails
     */
    endDate: ShiftiePlainDate | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeePayDetails
     */
    mode: EmployeePayDetailsModeEnum;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayDetails
     */
    hourlyRate: number;
    /**
     * 
     * @type {Date}
     * @memberof EmployeePayDetails
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmployeePayDetails
     */
    updatedAt: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum EmployeePayDetailsModeEnum {
    Fixed = 'Fixed',
    Percentage = 'Percentage'
}


/**
 * Check if a given object implements the EmployeePayDetails interface.
 */
export function instanceOfEmployeePayDetails(value: object): value is EmployeePayDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('payTypeId' in value) || value['payTypeId'] === undefined) return false;
    if (!('payCode' in value) || value['payCode'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function EmployeePayDetailsFromJSON(json: any): EmployeePayDetails {
    return EmployeePayDetailsFromJSONTyped(json, false);
}

export function EmployeePayDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeePayDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'jobRoleId': json['jobRoleId'],
        'payTypeId': json['payTypeId'],
        'payCode': json['payCode'],
        'startDate': ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': ShiftiePlainDateFromJSON(json['endDate']),
        'mode': json['mode'],
        'hourlyRate': json['hourlyRate'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function EmployeePayDetailsToJSON(json: any): EmployeePayDetails {
      return EmployeePayDetailsToJSONTyped(json, false);
  }

  export function EmployeePayDetailsToJSONTyped(value?: EmployeePayDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'payTypeId': value['payTypeId'],
        'payCode': value['payCode'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'mode': value['mode'],
        'hourlyRate': value['hourlyRate'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

